import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/Employee";
const base_url = process.env.REACT_APP_API_BASEURL;

export const getEmployeeBiligual = async () => {
  const data = await axios.get(`${api_base_url}/EmployeeBilingualOptions`);
  return data;
};
export const getEmployees = async () => {
  const { data } = await axios.get(`${api_base_url}`);
  return data;
};

export const getAllEmployees = async () => {
  const { data } = await axios.get(`${api_base_url}/AllEmployees`);
  return data;
};
export const getAllEmployeesForScoreCard = async () => {
  const { data } = await axios.get(`${api_base_url}/AllEmployeesForScoreCard`);
  return data;
};

export const getAllFranchiseEmployees = async () => {
  const { data } = await axios.get(`${api_base_url}/AllFranchiseEmployees`);
  return data;
};

export const addEmployees = async (newEmp) => {
  if (Array.isArray(newEmp.officecode)) {
    newEmp.officecode =
      newEmp.officecode && newEmp.officecode.map((x) => x.id)?.join(",");
  } else if (typeof newEmp.officecode === "object") {
    newEmp.officecode = newEmp.officecode;
  }
  newEmp.adOverrideGroup =
    newEmp.adOverrideGroup?.map((x) => x.value).join(",") || "";
  return await axios.post(`${api_base_url}`, {
    ...newEmp,
  });
};

export const editEmployee = async (updatedEmp) => {
  if (Array.isArray(updatedEmp.officecode)) {
    updatedEmp.officecode =
      updatedEmp.officecode &&
      updatedEmp.officecode.map((x) => x?.id)?.join(",");
  } else if (typeof updatedEmp.officecode === "object") {
    updatedEmp.officecode = updatedEmp.officecode;
  }
  updatedEmp.adOverrideGroup =
    updatedEmp.adOverrideGroup?.map((x) => x.value).join(",") || "";
  return await axios.put(`${api_base_url}`, {
    ...updatedEmp,
  });
};

export const deleteEmployeesByNumber = async (ids) => {
  return await axios.put(`${api_base_url}/EmployeesNumberToDelete`, ids);
};
export const getEmpOfficeState = async () => {
  return await axios.get(`${api_base_url}/EmpOfficeState`).then((res) => {
    if (res && res.status === 200) {
      return res.data;
    } else {
      return [];
    }
  });
};

export const getEmployeeOptions = async (isFranchise, isConfie) => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASEURL}/Common/EmployeeOptions?isFranchise=${isFranchise}&isConfie=${isConfie}`
    )
    .then((res) => {
      return res.data;
    });
};

export const getEmployeesBy = async ({ queryKey }) => {
  const [_key, filters] = queryKey;
  //Recontruct filter parameter as Query String for GET Method [FromQuery]
  var queryStrings = new URLSearchParams();
  if (filters) {
    filters.employeeId && queryStrings.append("EmployeeId", filters.employeeId);
    filters.Status && queryStrings.append("Status", filters.Status);
    filters.location && queryStrings.append("Location", filters.location);
    filters.employeeType &&
      queryStrings.append("EmployeeType", filters.employeeType);
    filters.businessOperation &&
      queryStrings.append("BusinessOperation", filters.businessOperation);
    filters.title && queryStrings.append("Title", filters.title);
    filters.employmentType &&
      queryStrings.append("EmploymentType", filters.employmentType);
    filters.terminationStatus &&
      queryStrings.append("TerminationStatus", filters.terminationStatus);
    filters.terminationReason &&
      queryStrings.append("TerminationReason", filters.terminationReason);
    filters.acquisition &&
      queryStrings.append("AcquisitionName", filters.acquisition);
  }
  var filterParams = {
    params: queryStrings,
  };
  return axios
    .get(`${api_base_url}/searchDetails`, filterParams)
    .then((res) => {
      return res.data;
    });
};

export const getEmployeesAsyncBackup = async (query, pageParams) => {
  try {
    let params;
    if (pageParams !== undefined) {
      params = Object.keys(pageParams).reduce((acc, key) => {
        const value = pageParams[key];

        if (
          value !== null &&
          value !== undefined &&
          !(typeof value === "string" && value.trim() === "")
        ) {
          acc[key] = value;
        }

        return acc;
      }, {});
    }
    var queryStrings = new URLSearchParams(params).toString();
    var size = query.pageSize !== undefined ? query.pageSize : 10;
    var pageNumber = isNaN(query.page) ? 1 : query.page;
    const url = queryStrings
      ? `${api_base_url}/EmployeesAsync?PageNumber=${
          pageNumber + 1
        }&PageSize=${size}&search=${query.search}&${queryStrings}`
      : `${api_base_url}/EmployeesAsync?PageNumber=${
          pageNumber + 1
        }&PageSize=${size}&search=${query.search}`;
    const response = await axios.get(url);
    // Parse headers only if they exist
    const headers = response?.headers
      ? JSON.parse(JSON.stringify(response.headers))
      : null;
    // Parse x-pagination header only if it exists
    const pageHeaders =
      headers && headers["x-pagination"]
        ? JSON.parse(headers["x-pagination"])
        : {};
    if (!response || !response?.data) {
      return {
        data: [],
        page: 0,
        pageSize: 0,
        totalCount: 0,
      };
    }

    return {
      data: response?.data ?? [],
      pageHeaders: pageHeaders,
      page: pageHeaders?.CurrentPage - 1,
      pageSize: pageHeaders?.PageSize,
      totalCount: pageHeaders?.TotalCount,
    };
  } catch (error) {
    throw error;
  }
};

// Get Employee Disply only
export const getEmployeesAsync = async (query, pageParams) => {
  let params;
  if (pageParams !== undefined) {
    params = Object.keys(pageParams).reduce((acc, key) => {
      const value = pageParams[key];
      if (
        value !== null &&
        value !== undefined &&
        !(typeof value === "string" && value.trim() === "")
      ) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }

  const queryStrings = new URLSearchParams(params).toString();
  const url = queryStrings
    ? `${api_base_url}/EmployeesAsync?search=${query.search}&${queryStrings}`
    : `${api_base_url}/EmployeesAsync?search=${query.search}`;

  const response = await axios.get(url);

  if (!response?.data) {
    return { data: [] };
  }

  return { data: response?.data ?? [] };
};

export const getEmployeesAsyncDownload = async (downloadParams) => {
  let params = {};

  if (downloadParams !== undefined) {
    params = Object.keys(downloadParams).reduce((acc, key) => {
      const value = downloadParams[key];

      if (typeof value === "boolean" || value?.length > 0 || value > 0) {
        acc[key] = value;
      }

      return acc;
    }, {});
  }

  const queryStrings = new URLSearchParams(params).toString();

  const url = queryStrings
    ? `${api_base_url}/EmployeesAsyncDownload?${queryStrings}`
    : `${api_base_url}/EmployeesAsyncDownload`;

  const response = await axios.post(url, null, {
    responseType: "blob",
  });

  return response.data;
};

export const getActiveEmployees = async () => {
  const { data } = await axios.get(`${api_base_url}/ActiveEmployees`);
  return data;
};

export const getEmployeesByEmployeeNumber = async (employeeNumber) => {
  let employeeNumberData;
  await axios
    .get(`${api_base_url}/employeeNumber/${employeeNumber}`)
    .then((res) => (employeeNumberData = res.data));
  return employeeNumberData;
};

export const getEmployeeTerminationStatus = async () => {
  const { data } = await axios.get(`${api_base_url}/EmployeeTerminationStatus`);
  return data;
};
export const getEmployeeTerminationReason = async () => {
  const { data } = await axios.get(`${api_base_url}/EmployeeTerminationReason`);
  return data;
};

export const getActiveConfieEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/ConfieActiveCount`);
  return data;
};

export const getOnLeaveConfieEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/ConfieOnLeaveCount`);
  return data;
};

export const getTerminatedConfieEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/ConfieTerminatedCount`);
  return data;
};

export const getActiveFranchiseEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/FranchiseActiveCount`);
  return data;
};

export const getOnLeaveFranchiseEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/FranchiseOnLeaveCount`);
  return data;
};

export const getTerminatedFranchiseEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/FranchiseTerminatedCount`);
  return data;
};

export const getRehireConfieEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/ConfieRehireCount`);
  return data;
};
export const getRehireFranchiseEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/FranchiseRehireCount`);
  return data;
};

export const getNewHireConfieEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/ConfieNewHireCount`);
  return data;
};
export const getNewHireFranchiseEmployeeCount = async () => {
  const { data } = await axios.get(`${api_base_url}/FranchiseNewHireCount`);
  return data;
};

export const getEmployeeTotalCount = async () => {
  return axios.get(`${api_base_url}/EmployeeTotalCount`).then((res) => {
    return res.data;
  });
};

export const getReportsToEmployeesOption = async () => {
  return axios.get(`${api_base_url}/ReportsToEmpOptions`).then((res) => {
    return res.data;
  });
};

export const getAcquisitionNameList = async () => {
  const { data } = await axios.get(`${api_base_url}/GetAcquisitionNameList`);
  return data;
};

export const getTressEmployeesCount = async () => {
  const { data } = await axios.get(`${api_base_url}/TressEmployeesCounts`);
  return data;
};

export const getHomeCompanies = async () => {
  const { data } = await axios.get(
    `${base_url}/EmployeeConfiguration/HomeCompanies`
  );
  return data;
};

export const getEmployeeHierarchyById = async (employeeId) => {
  const { data } = await axios.get(
    `${api_base_url}/EmployeeHierarchyById/${employeeId}`
  );

  return data;
};

export const getHrBusPartnerEmployees = async () => {
  const { data } = await axios.get(`${api_base_url}/HrBusPartnerEmployees`);
  return data;
};

export const getSeparationTypes = async () => {
  const { data } = await axios.get(`${api_base_url}/SeparationTypes`);
  return data;
};

export const getSeparationReasons = async () => {
  const { data } = await axios.get(`${api_base_url}/SeparationReasons`);
  return data;
};

export const getRehirables = async () => {
  const { data } = await axios.get(`${api_base_url}/Rehirables`);
  return data;
};

export const getProducerCodeByEmpId = async (employeeId) => {
  const { data } = await axios.get(
    `${base_url}/ProducerCode/ProducerEmp/${employeeId}`
  );
  return data;
};

export const getEmployeeOfficeHierarchyLeadership = async (employeeId) => {
  const { data } = await axios.get(
    `${api_base_url}/EmployeeOfficeHierarchyLeadership/${employeeId}`
  );
  return data;
};

export const getEmployeesByFullName = async (fullName, employeeId) => {
  const { data } = await axios.get(`${api_base_url}/EmployeeByFullName`, {
    params: {
      fullName,
      employeeId,
    },
  });
  return data;
};
